<template>
    <!-- Everything you need section -->
    <div class="py-12 md:py-20 px-4 md:px-8">
        <div class="max-w-5xl mx-auto">
            <div
                class="text-center mb-12 text-2xl md:text-4xl leading-tight"
            >
                <p class="text-slate-800 dark:text-slate-100">Everything you need to</p>
                <h2 class="font-medium text-orange">
                    maximize every point
                </h2>
            </div>

            <!-- Feature Cards -->
            <div class="space-y-16">
                <!-- Unlimited benefits tracker -->
                <div
                    class="flex flex-col lg:flex-row items-center gap-8 lg:gap-12"
                >
                    <div
                        class="flex-1 bg-white rounded-2xl shadow-sm border border-slate-200 p-4 overflow-hidden"
                    >
                        <img
                            src="../../../../images/desktop-illustration-benefits-tracker.png"
                            alt="Benefits Tracker"
                            class="w-full h-auto rounded-lg"
                        />
                    </div>
                    <div class="flex-1 lg:pl-4">
                        <h3
                            class="text-xl md:text-2xl font-medium text-slate-800 dark:text-slate-100"
                        >
                            Unlimited benefits tracker
                        </h3>
                        <p
                            class="text-slate-600 dark:text-slate-300 text-base mt-3 leading-relaxed"
                        >
                            Track perks and bonuses from loyalty programs linked
                            to your credit cards, so nothing gets missed.
                        </p>
                        <ul class="mt-4 space-y-3">
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>Clear overview of all card benefit</span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    See used and unused benefits at a glance
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>Never miss expiring benefits</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Best card to use -->
                <div
                    class="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12"
                >
                    <div
                        class="flex-1 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 p-4 overflow-hidden"
                    >
                        <img
                            src="../../../../images/desktop-illustration-best cards.png"
                            alt="Best Card to Use"
                            class="w-full h-auto rounded-lg"
                        />
                    </div>
                    <div class="flex-1 lg:pr-4">
                        <h3
                            class="text-xl md:text-2xl font-medium text-slate-800 dark:text-slate-100"
                        >
                            Always swipe the right card.
                            <span class="text-orange">Every time.</span>
                        </h3>
                        <p
                            class="text-slate-800 dark:text-slate-100 text-base mt-3 leading-relaxed"
                        >
                            Our Best Cards by Category feature looks at the
                            specific cards in your My10x wallet and tells you
                            exactly which one earns the most rewards for each
                            spending category.
                        </p>
                        <ul class="mt-4 space-y-3">
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Personalized to your exact wallet, not
                                    generic advice for someone else's cards
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Covers all major spending categories
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Updates automatically when you add or remove
                                    cards from your wallet
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Import bookings to redemption tracker -->
                <div
                    class="flex flex-col lg:flex-row items-center gap-8 lg:gap-12"
                >
                    <div
                        class="flex-1 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 p-4 overflow-hidden"
                    >
                        <img
                            src="../../../../images/desktop-illustration-redemptions.png"
                            alt="Redemption Tracker"
                            class="w-full h-auto rounded-lg"
                        />
                    </div>
                    <div class="flex-1 lg:pl-4">
                        <h3
                            class="text-xl md:text-2xl font-medium text-slate-800 dark:text-slate-100"
                        >
                            Forward your confirmation. We'll handle the rest.
                        </h3>
                        <p
                            class="text-slate-800 dark:text-slate-100 text-base mt-3 leading-relaxed"
                        >
                            Keeping track of redemptions manually is tedious.
                            With our redemption tracker, you just forward your
                            flight and hotel confirmation emails, and your
                            redemptions are created automatically, with all the
                            details filled in.
                        </p>
                        <ul class="mt-4 space-y-3">
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Less manual entry to keep track of your
                                    trips
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Faster and cleaner redemption tracking
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    All your award bookings in one place
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Transfer bonus alerts -->
                <div
                    v-if="transferBonusAlertsEnabled"
                    class="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12"
                >
                    <div
                        class="flex-1 bg-white rounded-2xl shadow-sm border border-slate-200 p-4 overflow-hidden"
                    >
                        <img
                            src="../../../../images/desktop-illustration-transfer-bonus-alerts.png"
                            alt="Transfer bonus alerts"
                            class="w-full h-auto rounded-lg"
                        />
                    </div>
                    <div class="flex-1 lg:pr-4">
                        <h3
                            class="text-xl md:text-2xl font-medium text-slate-800"
                        >
                            Be the first to know about every transfer bonus.
                        </h3>
                        <p
                            class="text-slate-800 text-base mt-3 leading-relaxed"
                        >
                            We'll let you know about transfer bonuses so you can
                            make your hard-earned points go even further.
                        </p>
                        <ul class="mt-4 space-y-3">
                            <li
                                class="flex items-center gap-3 text-base text-slate-800"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center flex-shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Email and push notifications about bonuses
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center flex-shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Customized recommendations based on the
                                    points in your wallet
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center flex-shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    See alerts for your favorite travel partners
                                    and explore new transfer options
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- TODO: Add this back when we have the points sync feature -->
                <!-- Unlimited bonus auto-sync -->
                <!-- <div
                    class="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12"
                >
                    <div
                        class="flex-1 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 p-4 overflow-hidden"
                    >
                        <img
                            src="../../../../images/desktop-illustration-points.png"
                            alt="Bonus Auto-sync"
                            class="w-full h-auto rounded-lg"
                        />
                    </div>

                    <div class="flex-1 lg:pr-4">
                        <h3
                            class="text-xl md:text-2xl font-medium text-slate-800 dark:text-slate-100"
                        >
                            All your points balances. Always up to date.
                        </h3>
                        <p
                            class="text-slate-800 dark:text-slate-100 text-base mt-3 leading-relaxed"
                        >
                            Automatically sync all your loyalty programs. No
                            more logging into six different accounts just to
                            figure out what you have to work with.
                        </p>
                        <ul class="mt-4 space-y-3">
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    All your points balances in one place
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Syncs automatically, no manual updates
                                    needed
                                </span>
                            </li>
                            <li
                                class="flex items-center gap-3 text-base text-slate-800 dark:text-slate-100"
                            >
                                <span
                                    class="w-5 h-5 rounded-full bg-orange flex items-center justify-center shrink-0"
                                >
                                    <Icon
                                        icon="check"
                                        :width="20"
                                        :height="20"
                                        class="text-white"
                                    />
                                </span>
                                <span>
                                    Always know exactly what you have before
                                    you start planning a trip
                                </span>
                            </li>
                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

const { transferBonusAlertsEnabled } = useFeatureFlags();
</script>
